import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import type { Taxonomie } from "../../API/Models";
import { client } from "../../Clients";

export interface TaxonomiesState {
	items: Taxonomie[];
	loading: boolean;
	isRefreshing: boolean;
	error?: string | null;
	initialized: boolean;
	lastUpdated: string | null;
}

const initialState: TaxonomiesState = {
	items: [],
	loading: false,
	isRefreshing: false,
	error: null,
	initialized: false,
	lastUpdated: null
};

const taxonomiesSlice = createSlice({
	name: "taxonomies",
	initialState,
	reducers: {
		setLoading(state, action: PayloadAction<boolean>) {
			state.loading = action.payload;
		},
		setRefreshing(state, action: PayloadAction<boolean>) {
			state.isRefreshing = action.payload;
		},
		setTaxonomies(state, action: PayloadAction<Taxonomie[]>) {
			state.items = action.payload ?? [];
			state.initialized = true;
			state.error = null;
			state.lastUpdated = new Date().toISOString();
		},
		setError(state, action: PayloadAction<string | null>) {
			state.error = action.payload;
			state.loading = false;
			state.isRefreshing = false;
		}
	}
});

export const { setLoading, setRefreshing, setTaxonomies, setError } = taxonomiesSlice.actions;
export const { reducer } = taxonomiesSlice;

export const fetchTaxonomies = (manual = false) => async (dispatch: Dispatch) => {
	if (manual) {
		dispatch(setRefreshing(true));
	} else {
		dispatch(setLoading(true));
	}
	try {
		const response = await client.taxonomies.apiTaxonomiesGet();
		dispatch(setTaxonomies(response.data ?? []));
	} catch (err: any) {
		dispatch(setError(err?.message ?? "Unable to load taxonomies"));
	} finally {
		if (manual) {
			dispatch(setRefreshing(false));
		} else {
			dispatch(setLoading(false));
		}
	}
};

